import { FEATURES } from '../../constants/features.constants';
import { isCollaborator } from './auth.selector';

export const isFeatureEnabled = ({ organization, auth }, feature = '') => {
  try {
    const { features: userFeatures = [] } = auth?.user || {};
    const { features: organizationFeatures = [] } = organization || {};

    const features = new Set([...userFeatures, ...organizationFeatures]);

    return features.has(feature);
  } catch (e) {
    console.error(e.message);
    return false;
  }
};

export const isAvatarsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.AVATARS);

export const isContactsFeatureEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.CONTACTS);

export const isSuggestContentFeatureEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.SUGGEST_CONTENT);

export const isImprovedSearchEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.IMPROVED_SEARCH);

export const isTermsAndConditionsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.TERMS_AND_CONDITIONS);

export const isSuggestKeywordsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.SUGGEST_KEYWORDS);

export const isRotationsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.ROTATIONS);

export const isScheduleAssignmentsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.SCHEDULE_ASSIGNMENTS);

export const isScheduleEducationalEventsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.SCHEDULE_EDUCATIONAL_EVENTS);

// True when the org has at least one of the three schedule entry points enabled.
// Used to decide whether to show the Schedule entry (home widget, manage section).
export const isAnyScheduleEnabled = ({ organization = {}, auth = {} }) =>
  isScheduleAssignmentsEnabled({ organization, auth }) ||
  isRotationsEnabled({ organization, auth }) ||
  isScheduleEducationalEventsEnabled({ organization, auth });

export const isAIEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.AI_ASK_PANDA);

export const isApprovalMarkEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.APPROVAL_MARK);

export const isKnowledgeHubSharedEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.KNOWLEDGE_HUB_SHARED);

export const isKnowledgeHubAccessEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.KNOWLEDGE_HUB_ACCESS);

export const isOwnerPermissionsRestrictionEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.PERMISSIONS_OWNER_RESTRICTION);

export const isKnowledgeCommentsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.KNOWLEDGE_COMMENTS);

export const isProvidedByEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.PROVIDED_BY);

export const isWorkspaceRestrictionsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.WORKSPACE_RESTRICTIONS);

export const isQualityMetricsEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.QUALITY_METRICS);

export const isMyContentEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.MY_CONTENT) && isCollaborator({ auth });

export const isQualityMetricsCasesEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.QUALITY_METRICS_CASES);

export const isDocumentEditorEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.DOCUMENT_EDITOR);

export const isKnowledgeTreeCopyEnabled = ({ organization = {}, auth = {} }) =>
  isFeatureEnabled({ organization, auth }, FEATURES.ALLOW_KNOWLEDGE_TREE_COPY);
